import { createAsyncThunk } from '@reduxjs/toolkit';

import ApplyProcessApi, { ICreateOrUpdateBorrowerRequest } from 'api/curo/ApplyProcessApi';
import { ApplyProcessActionTypes } from 'enums/curo/ApplyProcessActionTypes';

export const createUpdateBorrowerThunk = (api: ApplyProcessApi) =>
  createAsyncThunk(
    ApplyProcessActionTypes.UpdateBorrower,
    async ({ borrowerId, ...data }: ICreateOrUpdateBorrowerRequest & { borrowerId: string }) => {
      const response = await api.updateBorrower(borrowerId, data);
      return response;
    },
  );
